import Axios from 'axios';

// eslint-disable-next-line import/prefer-default-export
export async function getUserBasicDetailsByMitraAppBackendUserId(userId) {
  return (await Axios.get(`${process.env.REACT_APP_API_HOST}/users/basicDetails/${userId}`)).data;
}
